// src/pages/GalaxyPage.jsx
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import useAxios from "../useAxios";
import videoFile from "../assests/img/02.webm";
import starglow from "../assests/img/star.webp"

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

function visualRadius(label, scale = 1) {
  const chars = Math.max(8, label.length);
  return (chars * 0.25 + 3) * scale; // % units tuned for current CSS
}

function distance(a, b) {
  const dx = a.left - b.left;
  const dy = a.top - b.top;
  return Math.hypot(dx, dy);
}

function collides(candidate, others) {
  const R1 = visualRadius(candidate.label || candidate.name, candidate.size);
  return others.some(
    (o) => distance(candidate, o) < R1 + visualRadius(o.name || o.label, o.size)
  );
}

function randomCandidate(label) {
  return {
    label,
    top: Math.random() * 78 + 11, // 11–89% to keep away from edges
    left: Math.random() * 78 + 11,
    size: Math.random() * 1.1 + 1.2, // 1.2–2.3
  };
}

function placeNonOverlapping(label, others) {
  // try random positions first
  for (let i = 0; i < 250; i++) {
    const cand = randomCandidate(label);
    if (!collides(cand, others)) return cand;
  }
  // spiral fallback from center
  const center = { top: 50, left: 50 };
  let angle = 0;
  for (let r = 8; r <= 38; r += 1.4) {
    angle += 28;
    const rad = (angle * Math.PI) / 180;
    const cand = {
      label,
      top: clamp(center.top + Math.sin(rad) * r, 11, 89),
      left: clamp(center.left + Math.cos(rad) * r, 11, 89),
      size: Math.random() * 1.1 + 1.2,
    };
    if (!collides(cand, others)) return cand;
  }
  // last resort
  return randomCandidate(label);
}

export default function GalaxyPage() {
  //const [params] = useSearchParams();
  const axiosData = useAxios();
  const navigate = useNavigate();
  // const newName = (params.get("name") || "").trim();
  const [stars, setStars] = useState(() => {
    // load fixed positions if you refresh the big screen
    try {
      return JSON.parse(localStorage.getItem("stars") || "[]");
    } catch {
      return [];
    }
  });
  // const fetchData =async()=>{
  //  let saved=[] ;
  // try{
  // const dataAll = await axiosData.get("createData/getall")
  // const Getdata = dataAll.data
  // const Getdata2 = Getdata.map((data)=>{
  //  const name = data.name.toUpperCase();
  // if (!(name === newName)) {
  //         const placed = placeNonOverlapping(name, saved);
  //         saved.push({ id: data._id, name, tag: "I Stand With 117K", ...placed });
  //     }
  // })
  // setStars(saved);
  // }catch(err){
  // console.error("Error",err)
  // }
  // }
  // useEffect(() => {
  //   fetchData();
  //   const interval = setInterval(fetchData,5000)//every 5 seconds run
  //   return()=>clearInterval(interval)
  //   //let saved = JSON.parse(localStorage.getItem("stars") || "[]");
  //   // if (newName) {
  //   //   const label = newName.toUpperCase();
  //   //   if (!saved.find((s) => s.label === label)) {
  //   //     const placed = placeNonOverlapping(label, saved);
  //   //     saved.push({ id: label, label, tag: "I Stand With 117K", ...placed });
  //   //   }
  //   // }

  //   // setStars(saved);
  //   //localStorage.setItem("stars", JSON.stringify(saved));
  // }, []);
  // keep localStorage in sync (optional but recommended)
  useEffect(() => {
    localStorage.setItem("stars", JSON.stringify(stars));
  }, [stars]);

  useEffect(() => {
    let stop = false;

    const fetchAndMerge = async () => {
      try {
        const res = await axiosData.get("createData/getall");
        const list = res.data || [];

        // Merge into existing stars without moving old ones
        setStars((prev) => {
          // Map for quick “already placed?” checks
          const byId = new Map(prev.map((s) => [s.id, s]));
          const byName = new Map(prev.map((s) => [s.name, s])); // fallback

          let next = [...prev]; // start with existing positions

          for (const d of list) {
            const label = (d.name || "").toUpperCase();
            if (!label) continue;

            const id = d._id || label;

            // if already placed, KEEP the same position
            if (byId.has(id) || byName.has(label)) continue;

            // new name => place now, avoiding overlap with ALL names already in 'next'
            const placed = placeNonOverlapping(label, next);
            next.push({ id, name: label, ...placed });
          }

          return next;
        });
      } catch (e) {
        console.error("fetch failed", e);
      }
    };

    // initial load + polling every 5s
    fetchAndMerge();
    const t = setInterval(() => !stop && fetchAndMerge(), 5000);
    return () => {
      stop = true;
      clearInterval(t);
    };
  }, []);
  return (
    <div className="screen screen--galaxy background">


        <div className="galaxy">
        {stars.map((star) => (
          <div
            key={star.id}
            className={`star`}
            style={{
              top: `${star.top}%`,
              left: `${star.left}%`,
              transform: `translate(-50%, -50%) scale(${star.size})`,
            }}
          >
            <img src={starglow} className="star-dot" />
            <div className="star-text">
              <div className="star-name">{star.name}</div>
            </div>
          </div>
        ))}
      </div>
        <video autoPlay loop muted playsInline className="video-bg">
        <source src={videoFile} type="video/webm" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
